import { Image } from '@storyofams/storyblok-toolkit';
import { Heading } from '../Heading';
import { RichText } from '../Molecules';

export const WebinarDescription = ({ content }) => {
  return (
    <div className="w-full max-w-6xl px-4 mx-auto flex flex-col-reverse lg:flex-row justify-between py-20">
      <div className="flex flex-col space-y-12 mt-12 lg:mt-0">
        {content?.hosts?.length > 0 && (
          <div>
            <Heading as="h6" variant="h6" className="mb-6 text-gray-700">
              Hosted by
            </Heading>
            {content?.hosts?.map((host, i) => (
              <div
                key={i}
                className="flex items-center space-x-4 mb-4 last:mb-0"
              >
                {!!host?.content?.photo?.filename && (
                  <div className="rounded-full h-16 w-16 overflow-hidden grayscale">
                    <Image
                      alt={
                        host?.content?.photo?.alt || host?.content?.name || ''
                      }
                      src={host?.content?.photo?.filename}
                      fluid={64}
                      fit="contain"
                      showPlaceholder={false}
                      width="100%"
                      height="100%"
                      className="rounded-full overflow-hidden"
                    />
                  </div>
                )}
                <div className="text-gray-800">
                  <div className="text-lg font-bold">{host?.content?.name}</div>
                  <div className="text-sm">{host?.content?.position}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {content?.extra_info?.length > 0 &&
          content?.extra_info?.map((info, i) => (
            <div key={i}>
              {!!info?.text && (
                <Heading as="h6" variant="h6" className="mb-2 text-gray-700">
                  {info?.text}
                </Heading>
              )}
              <div className="text-lg text-gray-600">{info?.subtext}</div>
            </div>
          ))}
      </div>

      <div className="w-full mx-auto lg:max-w-2xl">
        {!!content?.about && (
          <RichText text={content?.about} textClassName="text-gray-800" />
        )}
      </div>
    </div>
  );
};
